import React from "react";
import PropTypes from "prop-types";
//Material imports
import withStyles from "@mui/styles/withStyles";
import IconButton from "@mui/material/IconButton";
//limitless import
import Typography from "@limitless/modern/data-display/typography/Typography";
import { useTranslation } from "@limitless/common/hooks";
import CloudUploadIcon from "@limitless/icons/CloudUploadIcon";
const FilePickerField = ({
  classes,
  value,
  loading,
  disabled,
  onChange,
  id,
  acceptCriteria,
  error = null
}) => {
  const [inputKey, setInputKey] = React.useState(Math.random().toString(36));
  const drop = React.useRef(null);
  const {
    t
  } = useTranslation();
  React.useEffect(() => {
    if (!value) {
      setInputKey(Math.random().toString(36));
    }
  }, [value]);
  React.useEffect(() => {
    var _drop$current, _drop$current2;
    drop === null || drop === void 0 ? void 0 : (_drop$current = drop.current) === null || _drop$current === void 0 ? void 0 : _drop$current.addEventListener("dragover", handleDragOver);
    drop === null || drop === void 0 ? void 0 : (_drop$current2 = drop.current) === null || _drop$current2 === void 0 ? void 0 : _drop$current2.addEventListener("drop", handleDrop);
  }, []);
  const handleDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) {
      const {
        files
      } = e.dataTransfer;
      const file = files[0];
      onChange(file ? file : null);
    }
  };
  const handleFileSelected = event => {
    event.stopPropagation();
    event.preventDefault();
    const file = event.target.files[0];
    onChange(file ? file : null);
  };
  const handleBrowseExplorer = event => {
    event.preventDefault();
    document.getElementById(id).click();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.fileFieldContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.title
  }, t("Select a file")), /*#__PURE__*/React.createElement("div", {
    ref: drop,
    style: {
      marginTop: "4px"
    }
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    key: inputKey,
    type: "file",
    accept: typeof acceptCriteria === "string" ? acceptCriteria.replaceAll("|", ",") : acceptCriteria === null ? "image/*" : ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
    onChange: handleFileSelected,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: `${classes.typographyContainer} ${error !== "" && typeof error === "string" ? classes.typographyErrorContainer : ""}`
  }, /*#__PURE__*/React.createElement(Typography, {
    className: `${classes.typography} ${value === null || error !== "" && error !== null ? classes.disabledTypography : ""}`
  }, value !== null && (error === "" || error === null) ? value.name : t("Drag and drop or click to upload"))), error !== "" ? /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "error"
  }, t(error)) : typeof error === "string" && /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.text.secondary
    }
  }, t("File type: .jpeg, .png or .bmp. Max size allowed: 5MB")), /*#__PURE__*/React.createElement(IconButton, {
    id: "fileSelectButton",
    className: classes.fileSelectBtn,
    onClick: handleBrowseExplorer,
    disabled: loading || disabled
  }, /*#__PURE__*/React.createElement(CloudUploadIcon, {
    color: "primary"
  }))));
};
const styles = theme => ({
  fileFieldContainer: {
    height: 92,
    position: "relative"
  },
  title: {
    marginBottom: 4,
    color: theme.palette.grey[4]
  },
  typographyContainer: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: theme.background.elevation1,
    height: 55,
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: 8,
    alignItems: "center",
    overflow: "hidden",
    marginBottom: "4px"
  },
  typography: {
    width: 320,
    marginLeft: 16
  },
  fileSelectBtn: {
    position: "absolute",
    right: 7,
    bottom: 24,
    width: 40
  },
  typographyErrorContainer: {
    borderColor: theme.palette.error.main
  },
  disabledTypography: {
    color: theme.palette.text.disabled
  }
});
export default withStyles(styles)(FilePickerField);
FilePickerField.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  acceptCriteria: PropTypes.string,
  error: PropTypes.string
};
FilePickerField.defaultProps = {
  value: null,
  loading: false,
  disabled: false,
  id: "browseFile"
};